import { Component, DoCheck, OnInit } from '@angular/core';
import { NgbDropdownConfig } from '@ng-bootstrap/ng-bootstrap';
import { animate, style, transition, trigger } from '@angular/animations';
import { ThemeConfig } from '../../../../../app-config';
import { PATHS_LOGIN_PAGES } from 'src/app/commons/config/path-pages';
import { SessionStorageService } from 'src/app/commons/services/local/storage/storage.service';
import { AuthService } from 'src/app/commons/services/local/auth-services';
import { DataUserService } from 'src/app/commons/services/local/data-user.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-nav-right',
  templateUrl: './nav-right.component.html',
  styleUrls: ['./nav-right.component.scss'],
  providers: [NgbDropdownConfig],
  animations: [
    trigger('slideInOutLeft', [
      transition(':enter', [style({ transform: 'translateX(100%)' }), animate('300ms ease-in', style({ transform: 'translateX(0%)' }))]),
      transition(':leave', [animate('300ms ease-in', style({ transform: 'translateX(100%)' }))])
    ]),
    trigger('slideInOutRight', [
      transition(':enter', [style({ transform: 'translateX(-100%)' }), animate('300ms ease-in', style({ transform: 'translateX(0%)' }))]),
      transition(':leave', [animate('300ms ease-in', style({ transform: 'translateX(-100%)' }))])
    ])
  ]
})
export class NavRightComponent implements OnInit, DoCheck {
  public visibleUserList: boolean;
  public chatMessage: boolean;
  public friendId: boolean;
  public config: any;

  constructor(config: NgbDropdownConfig, 
    private _sessionStorageService: SessionStorageService,
    private _router: Router, private _authService: AuthService,
    private _dataUserService: DataUserService) {
    config.placement = 'bottom-right';
    this.visibleUserList = false;
    this.chatMessage = false;
    this.config = ThemeConfig.config;
  }

  usuario: string;

  ngOnInit() {
    this.usuario = this._dataUserService.getFullName() as string;
  }

  onChatToggle(friend_id) {
    this.friendId = friend_id;
    this.chatMessage = !this.chatMessage;
  }

  ngDoCheck() {
    if (document.querySelector('body').classList.contains('datta-rtl')) {
      this.config['rtl-layout'] = true;
    } else {
      this.config['rtl-layout'] = false;
    }
  }

  clickLogOut(): void {		
		this._sessionStorageService.clear();    
    this._authService.logout();
		void this._router.navigateByUrl(PATHS_LOGIN_PAGES.loginPage.withSlash);
	}

}
